import { useEffect, useState } from "react";

function ImageWithLoader({ src, alt, className }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="position-relative bg-white">
      <img
        src={src}
        alt={alt}
        className={className}
        style={{
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.4s ease",
        }}
        onLoad={() => setLoaded(true)}
        loading="lazy"
      />
    </div>
  );
}

export default function Portfolio() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    fetch("/api/admin/medias/rows.php")
      .then(res => res.json())
      .then(data => setRows(data));
  }, []);

  return (
    <div className="container" style={{ maxWidth: '700px' }}>
      {rows.map((row) => (
        <div key={row.id} className="row mb-4">

          {/* FULL WIDTH */}
          {row.layout === "one" && (
            <div className="col-12">
              <figure className="mb-0">
                <ImageWithLoader
                  src={row.image_1}
                  className="img-fluid w-100"
                  alt=""
                />
                {row.credit_1 && (
                  <figcaption className="photo-credit">
                    @ {row.credit_1}
                  </figcaption>
                )}
              </figure>
            </div>
          )}

          {/* TWO IMAGES EN LIGNE */}
          {row.layout === "two" && (
            <>
              <div className="col-md-6">
                <figure className="mb-0">
                  <ImageWithLoader
                    src={row.image_1}
                    className="img-fluid w-100"
                    alt=""
                  />
                  {row.credit_1 && (
                    <figcaption className="photo-credit">
                      @ {row.credit_1}
                    </figcaption>
                  )}
                </figure>
              </div>

              <div className="col-md-6">
                <figure className="mb-0">
                  <ImageWithLoader
                    src={row.image_2}
                    className="img-fluid w-100"
                    alt=""
                  />
                  {row.credit_2 && (
                    <figcaption className="photo-credit">
                      @ {row.credit_2}
                    </figcaption>
                  )}
                </figure>
              </div>
            </>
          )}

        </div>
      ))}
    </div>
  );
}